import { WrappedPatient } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient';
import { CustomModalBasicProps } from '../../../../../components/CustomModal';
import { WrappedServiceRequest } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/ServiceRequest';
import { TaskWrapper, WrappedTask } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Task';
import { TaskModalResolver } from 'src/careflow/care-coordination/task/patient/TasksGrid/TaskModalResolver';

interface Props extends CustomModalBasicProps {
  patient: WrappedPatient | null;
  serviceRequest?: WrappedServiceRequest | null;
  task?: WrappedTask | null;
  open: boolean;
  handleSave: (data: any) => void;
  onClose: () => void;
}

const EditTaskDialog = ({ patient, serviceRequest, task, open, onClose, handleSave }: Props) => {
  const taskWrapped = task ? TaskWrapper(task) : undefined;
  return (
    <TaskModalResolver
      taskToEdit={taskWrapped}
      onSuccessfulEdit={handleSave}
      onSuccessfulCreation={handleSave}
      patientExternal={patient}
      open={open}
      onClose={onClose}
    />
  );
};

export default EditTaskDialog;
